<!DOCTYPE html>
<template>
<div class="help">

  <b-card class="shadow"
          no-body>
    <template v-if="!gotHelp">


      <h1>Need help?</h1>
      <p>
        We can help get you set up. Simply enter your email and we'll reach out and continue the process with an expert by your side.
      </p>

      <b-input placeholder="Email address"
               v-model="email">Email address</b-input>
      <b-button variant="success"
                @click="getHelp">Get help</b-button>


    </template>


    <template v-else>
      <h1>Help is on the way</h1>
      <p>
        A representative will contact you via email and help you get started.
      </p>
      <b-button variant="success"
                to="/">Great</b-button>
    </template>
  </b-card>



</div>
</template>

<script>
export default {
  name: 'Help',
  components: {},
  methods: {
    getHelp() {
      // SEND EMAIL HERE
      this.gotHelp = true
    }
  },
  computed: {},
  data() {
    return {
      email: null,
      gotHelp: false
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/styles/overrides.scss";

.help {
    display: grid;
    justify-content: center;

    .card {
        color: $primary;
        display: grid;
        max-width: 600px;
        grid-row-gap: 1rem;
        width: auto;
        margin: 5rem auto;
        padding: 5rem;
        justify-content: center;
        justify-items: flex-start;
    }
}
</style>
